(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parseBool(val) {
    if (typeof val === 'boolean') return val;
    if (!val) return false;
    return String(val).toLowerCase() === 'true' || String(val) === '1';
  }

  function initSlideshow(component) {
    if (!component || component.dataset._slideshowInit) return;
    component.dataset._slideshowInit = '1';

    const slider = component.querySelector('.slider');
    if (!slider) return;
    const slides = Array.from(component.querySelectorAll('.slider__slide'));
    if (slides.length === 0) return;

    // Create a track and move slides into it (prevents CSS conflicts)
    const track = document.createElement('div');
    track.className = 'slider-track';
    slides.forEach(s => track.appendChild(s));
    slider.appendChild(track);

    let index = 0;
    const speedSec = parseInt(component.dataset.speed) || 5;
    const speed = speedSec * 1000;
    const autoplay = parseBool(component.dataset.autoplay);

    // Ensure layout ready
    track.style.transform = 'translateX(0%)';

    function updateUI() {
      track.style.transform = `translateX(-${index * 100}%)`;
      // Keep is-active class for compatibility with existing CSS
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      // update dots
      const dots = Array.from(component.querySelectorAll('.slider-counter__link'));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      const counterCurrent = component.querySelector('.slider-counter--current');
      if (counterCurrent) counterCurrent.textContent = (index + 1).toString();
    }

    updateUI();

    let timer = null;
    function startAuto() {
      stopAuto();
      if (!autoplay || slides.length <= 1) return;
      timer = setInterval(() => {
        index = (index + 1) % slides.length;
        updateUI();
      }, speed);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Controls
    const prev = component.querySelector('.slider-button--prev');
    const next = component.querySelector('.slider-button--next');
    if (prev) prev.addEventListener('click', () => { index = (index - 1 + slides.length) % slides.length; updateUI(); });
    if (next) next.addEventListener('click', () => { index = (index + 1) % slides.length; updateUI(); });

    // Dots clickable
    const dots = Array.from(component.querySelectorAll('.slider-counter__link'));
    dots.forEach((dot, i) => dot.addEventListener('click', (e) => { e.preventDefault(); index = i; updateUI(); }));

    // Pause/resume
    component.addEventListener('mouseenter', stopAuto);
    component.addEventListener('mouseleave', startAuto);
    component.addEventListener('touchstart', stopAuto, { passive: true });
    component.addEventListener('touchend', startAuto, { passive: true });

    // Wait for images to load before starting autoplay
    const imgs = Array.from(component.querySelectorAll('img'));
    if (imgs.length === 0) startAuto();
    else {
      let loaded = 0;
      imgs.forEach(img => {
        if (img.complete) {
          loaded++;
          if (loaded === imgs.length) startAuto();
        } else {
          img.addEventListener('load', () => { loaded++; if (loaded === imgs.length) startAuto(); });
          img.addEventListener('error', () => { loaded++; if (loaded === imgs.length) startAuto(); });
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('slideshow-component').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
